import { JourneysApi } from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

class JourneyService {
  private readonly httpClient = createApiClient(JourneysApi)

  async getOpenJourneys() {
    const { data } = await this.httpClient.openJourneys()

    return data
  }
}

export const journeyService = new JourneyService()
